import {DomainObject} from 'shared/store';
import { observable, makeObservable } from 'mobx';

class TimeTrackingDimension extends DomainObject {
  name;
  order;

  constructor(other) {
    super();

    makeObservable(this, {
      name: observable,
      order: observable
    });

    this.merge(other);
  }
}

export default TimeTrackingDimension;
